// Build provenance shown in the footer, so it is always possible to tell which
// commit is actually live in a given environment.
//
// VITE_BUILD_NUMBER / VITE_COMMIT_SHA / VITE_ENVIRONMENT are injected by the
// pipeline at build time. __BUILD_TIME__ is stamped by vite.config.ts, so it is
// present even for a local build where the pipeline variables are absent.

declare const __BUILD_TIME__: string;

const ADO_REPO_URL =
    'https://dev.azure.com/axponential/Binary%20Internal/_git/BIKI';

const rawBuildNumber = (import.meta.env.VITE_BUILD_NUMBER ?? '').trim();
const rawCommitSha = (import.meta.env.VITE_COMMIT_SHA ?? '').trim();
const rawEnvironment = (import.meta.env.VITE_ENVIRONMENT ?? '').trim();

/** True when this bundle was produced by a developer machine, not the pipeline. */
export const isLocalBuild = rawBuildNumber === '';

/** e.g. "20260904.5", or "local" for a developer build. */
export const buildNumber = isLocalBuild ? 'local' : rawBuildNumber;

/** Full commit SHA, or '' when unknown. */
export const commitSha = rawCommitSha;

/** First 8 characters of the commit SHA, or '' when unknown. */
export const shortCommitSha = rawCommitSha.slice(0, 8);

/** "Production" | "Dev" | "Local". */
export const environmentName = rawEnvironment || 'Local';

/** Link to this exact commit in Azure DevOps, or null when the SHA is unknown. */
export const commitUrl = rawCommitSha
    ? `${ADO_REPO_URL}/commit/${rawCommitSha}`
    : null;

/** ISO timestamp of when the bundle was built. */
export const buildTime = __BUILD_TIME__;

/** Build time rendered for display, falling back to the raw value if unparseable. */
export function formattedBuildTime(): string {
    const parsed = new Date(buildTime);
    if (Number.isNaN(parsed.getTime())) return buildTime;
    return parsed.toLocaleString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
}
